iScreenWizard.factory('nieuweTestafnameService', function ($state, $rootScope) {

    var service = {

        model: {
            kandidaat: {
                email: null,
                voornaam: null,
                achternaam: null,
                opleidingsniveau: null,
                taal_id: null,
            },
            group_code: null,
            rapporttemplate: null,
            competentieprofiel: null,
            mailtemplates: null,
            stuur_gebruiker_rapport: false,
            kenmerk: null
        },

        SaveState: function () {
            localStorage.nieuweTestafnameService = angular.toJson(service.model);
        },

        RestoreState: function () {
            if (typeof localStorage.nieuweTestafnameService !== 'undefined') {
                service.model = angular.fromJson(localStorage.nieuweTestafnameService);
            }
        }
    };

    $rootScope.$on("savestate", service.SaveState);
    $rootScope.$on("restorestate", service.RestoreState);

    service.RestoreState();

    return service;
});